import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'youtube-player',
    templateUrl: './youtube-player.template.html',
    styleUrls: ['./youtube-player.scss'],
})

export class YoutubePlayer implements OnInit {
  @Input() youtubeId: string;
  urlSafe: SafeResourceUrl;

  constructor(public sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.embedUrl);
  }

  get embedUrl(): string {
    // autoplay=1: Autoplay the video
    // rel=0: Related videos will come from the same channel as the video that was just played
    return `https://www.youtube.com/embed/${this.youtubeId}?autoplay=1&rel=0`;
  }
}



// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/youtube-player/youtube-player.component.ts